import Sidebar from "./Sidebar";
import RateTicker from "./RateTicker";
import TrialBanner from "./TrialBanner";
import InventoryAssistant from "./InventoryAssistant";
import PremiumFooter from "./PremiumFooter";
import { Toaster } from "sonner";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import { useSubscription } from "@/context/SubscriptionContext";
import ChangePasswordModal from "./ChangePasswordModal";
import { KeyRound, CreditCard } from "lucide-react";

export default function Layout({ children }) {
  const { user, refreshUser } = useAuth();
  const { t } = useI18n();
  const { hasActive, isTrial, loading } = useSubscription();
  const [pwOpen, setPwOpen] = useState(false);
  const forced = !!user?.must_change_password;
  // Only show the "no subscription" banner when the user has NO access at all
  // (trial exhausted + no paid sub). Trial-active users get the TrialBanner instead.
  const showSubBanner = user && !loading && !hasActive;

  return (
    <div className="min-h-screen flex bg-[--bg] overflow-x-hidden" style={{ background: "var(--bg)" }} data-testid="app-layout">
      <Sidebar onChangePassword={()=>setPwOpen(true)} />
      <div className="flex-1 flex flex-col min-w-0 overflow-x-hidden">
        <div
          className="sticky top-0 z-30 bg-[#050505] border-b border-white/8 overflow-x-hidden"
          style={{
            paddingTop: "env(safe-area-inset-top)",
            paddingLeft: "env(safe-area-inset-left)",
            paddingRight: "env(safe-area-inset-right)",
          }}
          data-testid="app-header"
        >
          {hasActive && <RateTicker />}
          {isTrial && <TrialBanner />}
          {showSubBanner && (
            <div className="pl-14 lg:pl-6 pr-6 py-3 flex items-center gap-3 text-xs flex-wrap" style={{background:"rgba(239,68,68,0.10)"}} data-testid="sub-banner">
              <CreditCard size={14} className="text-red-400" />
              <span className="flex-1 min-w-0 text-white">Deneme süreniz doldu. Kesintisiz erişim için aboneliğinizi başlatın.</span>
              <Link to="/pricing" className="underline hover:text-white whitespace-nowrap font-medium" style={{color:"var(--gold)"}} data-testid="sub-banner-cta">
                {t("gate.go_pricing")}
              </Link>
            </div>
          )}
          {forced && (
            <div className="pl-14 lg:pl-6 pr-6 py-2 border-t border-[--gold] flex items-center gap-3 text-xs flex-wrap" style={{background:"rgba(212,175,55,0.08)", borderTopColor:"var(--gold)"}} data-testid="force-pw-banner">
              <KeyRound size={12} style={{color:"var(--gold)"}} />
              <span className="flex-1 min-w-0">{t("security.default_pw")}</span>
              <button onClick={()=>setPwOpen(true)} className="underline hover:text-[--gold] whitespace-nowrap" style={{color:"var(--gold)"}} data-testid="banner-change-pw">{t("security.change_now")}</button>
            </div>
          )}
        </div>
        <main className="flex-1 p-4 pt-16 lg:p-8 lg:pt-8 xl:p-12 relative z-10 overflow-x-hidden">{children}</main>
        <PremiumFooter />
      </div>
      <ChangePasswordModal
        open={pwOpen || forced}
        forced={forced}
        onClose={()=>setPwOpen(false)}
        onDone={refreshUser}
      />
      {user && hasActive && <InventoryAssistant />}
      <Toaster theme="dark" position="top-right" />
    </div>
  );
}
